import { Button, Input, message, Popover, Select, Space, Spin, Tabs } from 'antd';
import styles from './index.module.scss'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { GenerateContext } from '../../../hooks/GenerateContext';
import API, { commonApiInvoker } from '@api/api';
import SelectionItem from '../SelectionItem';
import { RESOURCE_TYPE, RESOURCE_PARAMS, COMMODITY_SCENE_MODE, TRYON_CLOTH_TYPE, CLOTH_TYPE, IMAGE_TYPE } from '@utils/CONST'
import PSAIModal from '@PSAIComponents/PSAIModal';
import Utils from '@utils/utils';
import SelectionFilter from '../SelectionFilter';
import Iconfont from '@utils/Iconfont';
import ColorDataSet from '@utils/ColorDataSet';
import SelectionColorItem from '../SelectionColorItem';
import eventBus from '@utils/eventBus';
import UploadRequirements from '../UploadRequirements';
import { List } from 'antd/lib';
import ColorPalette from '../ColorPalette'
const imageBaseUrlV3 = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/";
const { TextArea } = Input;

// 自定义循环
const useCustomLoop = (props) => {
    const { custom, list, updateForce } = props
    const isLoop = useRef()
    const isMounted = useRef(true)

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const loopFunc = () => {
        updateForce({})
        if (isLoop.current && isMounted.current) {
            setTimeout(() => {
                loopFunc()
            }, 2000)
        }
    }

    useEffect(() => {
        if (!custom) return
        if (!isMounted.current) return
        const notSucc = !!list.find(item => item.attr && "maskStatus" in item.attr && item.attr.maskStatus != "succeeded")
        if (notSucc) {
            if (!isLoop.current) {
                isLoop.current = true
                loopFunc()
            }
        } else {
            if (isLoop.current) {
                isLoop.current = false
            }
        }
    }, [list, custom])
}

// 场景模式选择
const SceneModeSelection = (props) => {
    const { value, onChange } = props
    const options = [{
        label: "更加自由",
        value: COMMODITY_SCENE_MODE.SIMILAR_STYLE,
    }, {
        label: "更加相似",
        value: COMMODITY_SCENE_MODE.SAME_STYLE,
    }]
    return (
        <div className={styles.SceneModeSelection}>
            {
                options.map(item => (
                    <div
                        key={item.value}
                        className={`${styles.SceneModeSelection_item} ${value == item.value && styles.actived}`}
                        onClick={() => onChange(item.value)}
                    >
                        <span>{item.label}</span>
                        <Popover
                            classNames={{ root: styles.RefImgPopover }}
                            placement="bottomLeft"
                            arrow={false}
                            content={<UploadRequirements resourceType={RESOURCE_TYPE.COMMODITY_SCENE} commoditySceneMode={item.value} />}
                        >
                            <Iconfont type="icon-QuestionCircleOutlined" className={styles.Icon} />
                        </Popover>
                    </div>
                ))
            }
        </div>
    )
}

const PoseSelectionContent = (props) => {
    const {
        // 图片类型
        imageType,
        // 选中的pose
        value,
        // 资源类型
        resourceType,
        // 自定义资源
        custom,
        // 收藏资源
        favorite,
        // 推荐资源
        recommend,
        // 是否多选
        multiple = false,
        // 最大选择数量
        maxCount = 1,
        // 选择回调
        onChange,
        // 上传回调
        onUpload,
    } = props
    // 资源列表
    const [list, setList] = useState([])
    // loading
    const [loading, setLoading] = useState(false)
    const setLoadingDebounce = useCallback(_.debounce(setLoading, 500), [])
    // isEmpty
    const [isEmpty, setIsEmpty] = useState(false)
    // 筛选项
    const {
        resourceFilter,
        inputImage,
        inputImageClothType,
        inputImageOriginalMask,
        inputImageEditedMask,
        topInputImage,
        topInputImageOriginalMask,
        topInputImageEditedMask,
        bottomInputImage,
        bottomIopInputImageOriginalMask,
        bottomIopInputImageEditedMask,
        setRefImgStrength,
        setGlassesTryonKeyList,
        setSimTryonKeyList,
        getSemanticSimTryonMaskId,
        getSemanticSimTryonMaskIdClothTypeAll,
        setOutputRatio,
        setOutputWidth,
        setOutputHeight,
        setInputImageTransform,
    } = useContext(GenerateContext)
    // 分页
    const totalRef = useRef(1)
    // 刷新
    const [force, updateForce] = useState()
    // 场景模式选择
    const [commoditySceneMode, setCommoditySceneMode] = useState(COMMODITY_SCENE_MODE.SIMILAR_STYLE)
    // 收藏资源是否禁用
    const favorDisabled = useMemo(() => {
        return (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.MODEL) ||
            resourceType == RESOURCE_TYPE.TRYON_SCENE
    }, [imageType, resourceType])
    // 修改场景模式 相似风格(0.7);拍同款(0.6)
    const handleCommoditySceneModeChange = (value) => {
        if (value == COMMODITY_SCENE_MODE.SIMILAR_STYLE) {
            setRefImgStrength(0.7)
        } else {
            setRefImgStrength(0.6)
        }
        setCommoditySceneMode(value)
    }

    // 自定义循环
    useCustomLoop({
        list,
        custom,
        updateForce
    })

    // 外部触发更新自定义素材
    useEffect(() => {
        const updateCustomMaterial = () => updateForce({})
        if (custom || resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON) eventBus.on("updateCustomMaterial", updateCustomMaterial)
        return () => {
            if (custom || resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON) eventBus.off("updateCustomMaterial", updateCustomMaterial)
        }
    }, [])

    // 格式化列表
    const formatList = (list, selectedKeyList) => {
        const _list = list
            .filter(item => item.name != "00_default_style")
            .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
            .map(item => ({
                ...item,
                subList: item?.subList?.filter(item => !/_random$/.test(item.name))
            }))
            .map(item => ({
                ...item,
                isFavorite: item.attr.isFavorite,
                isCustom: "custom" in item.attr ? !!item.attr.custom : item.attr.skin == "custom",
                imageUrlWithVersion: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                subList: (item.subList ?? []).map(subItem => ({
                    ...subItem,
                    imageUrlWithVersion: Utils.addParamsToUrl(subItem.imageUrl, { version: subItem.attr.version }),
                    isFavorite: subItem.attr.isFavorite,
                }))
            }))
        // 将选中的子项提取出来
        for (let key of selectedKeyList) {
            for (let item of _list) {
                if (item.name == key) break
                let found = false
                const subList = item.subList || []
                for (let subItem of subList) {
                    if (subItem.name == key) {
                        item.id = subItem.id
                        item.name = subItem.name
                        item.imageUrl = subItem.imageUrl
                        item.imageUrlWithVersion = subItem.imageUrlWithVersion
                        item.isFavorite = subItem.isFavorite
                        item.attr.name = subItem.attr.name
                        found = true
                        break
                    }
                }
                if (found) break
            }
        }
        return _list
    }

    // 推荐素材刷新
    useEffect(() => {
        if (!RESOURCE_PARAMS[resourceType]) return
        if (!recommend) return

        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            const params = { ...RESOURCE_PARAMS[resourceType] }
            const { recommendCommodityType } = resourceFilter
            if (!!recommendCommodityType) params.commodityType = recommendCommodityType
            const api = API.getPresetResources2
            commonApiInvoker(api({
                ...params,
                pageIndex: 1,
                pageSize: 50000
            })).then(res => {
                const list = formatList(res?.items ?? [], selectedKeyList)
                setList(list)
                if (list.length == 0) setIsEmpty(true)
                else setIsEmpty(false)
            })
        } else {
            const { age, sex, skin, clothesCate } = resourceFilter
            const api = API.getTryonModelRecommend
            const params = { ...RESOURCE_PARAMS[resourceType] }
            if (age?.length > 0) params.age = age?.join()
            if (sex?.length > 0) params.sex = sex?.join()
            if (skin?.length > 0) params.skin = skin?.join()
            if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
            const editedMask = (
                inputImageEditedMask || inputImageOriginalMask ||
                topInputImageEditedMask || topInputImageOriginalMask ||
                bottomIopInputImageEditedMask || bottomIopInputImageOriginalMask
            )
            if (editedMask) {
                // clothImage
                params.clothImage = inputImage || topInputImage || bottomInputImage
                params.clothMask = editedMask.binaryMask
                params.clothType = inputImageClothType == TRYON_CLOTH_TYPE.TOP ? CLOTH_TYPE.SHIRT :
                    inputImageClothType == TRYON_CLOTH_TYPE.BOTTOM ? CLOTH_TYPE.PANTS :
                        inputImageClothType == TRYON_CLOTH_TYPE.DRESS ? CLOTH_TYPE.DRESS :
                            topInputImage ? CLOTH_TYPE.SHIRT :
                                CLOTH_TYPE.PANTS
                setLoadingDebounce(true)
                commonApiInvoker(api({
                    ...params,
                })).then(res => {
                    const list = formatList(res ?? [], selectedKeyList)
                    setList(list)
                    if (list.length == 0) setIsEmpty(true)
                    else setIsEmpty(false)
                }).finally(() => {
                    setLoadingDebounce(false)
                })
            } else {
                setLoadingDebounce(true)
                commonApiInvoker(api({
                    ...params,
                })).then(res => {
                    const list = formatList(res ?? [], selectedKeyList)
                    setList(list)
                    if (list.length == 0) setIsEmpty(true)
                    else setIsEmpty(false)
                }).finally(() => {
                    setLoadingDebounce(false)
                })
            }
        }
    }, [
        force, resourceType,
        recommend,
        selectedKeyList,
        resourceFilter,
        inputImage,
        inputImageClothType,
        topInputImage,
        bottomInputImage,
        inputImageOriginalMask,
        inputImageEditedMask,
        topInputImageOriginalMask,
        topInputImageEditedMask,
        bottomIopInputImageOriginalMask,
        bottomIopInputImageEditedMask,
    ])

    // 素材列表
    useEffect(() => {
        if (!RESOURCE_PARAMS[resourceType]) return
        if (recommend) return
        const { age, sex, skin, view, clothesCate, shoesType,
            pose, commodityType, sceneType, sceneTags, compositionTags,
            clothStyles, clothPatterns, clothTypes, toneTags } = resourceFilter

        if (custom || favorite) {
            const status = Utils.checkLoginStatus(() => updateForce({}))
            if (!status) return
        }

        const api = custom ? API.getCustomResources2 :
            favorite ? API.getFavoriteResources2 :
                API.getPresetResources2
        const params = { ...RESOURCE_PARAMS[resourceType] }
        if (!custom) {
            if (resourceType == RESOURCE_TYPE.MODEL) {
                if (age?.length > 0) params.age = age?.join()
                if (sex?.length > 0) params.sex = sex?.join()
                if (skin?.length > 0) params.skin = skin?.join()
                if (toneTags?.length > 0) params.toneTags = toneTags?.join()
            } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
                if (age?.length > 0) params.age = age?.join()
                if (sex?.length > 0) params.sex = sex?.join()
                if (skin?.length > 0) params.skin = skin?.join()
                if (toneTags?.length > 0) params.toneTags = toneTags?.join()
                if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
            } else if (resourceType == RESOURCE_TYPE.POSE_TRYON) {
                if (age?.length > 0) params.age = age?.join()
                if (sex?.length > 0) params.sex = sex?.join()
                if (view?.length > 0) params.view = view?.join()
            } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
                if (skin?.length > 0) params.skin = skin?.join()
                if (clothStyles?.length > 0) params.clothStyles = clothStyles?.join()
                if (clothPatterns?.length > 0) params.clothPatterns = clothPatterns?.join()
                if (clothTypes?.length > 0) params.clothTypes = clothTypes?.join()
            } else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
                if (sex?.length > 0) params.sex = sex?.join()
                if (shoesType?.length > 0) params.shoesType = shoesType?.join()
                if (pose?.length > 0) params.poseType = pose?.join()
            } else if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
                if (sex?.length > 0) params.sex = sex?.join()
            } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
                if (!!commodityType) params.commodityType = commodityType
                if (!!sceneType) params.sceneType = sceneType
            } else if (resourceType == RESOURCE_TYPE.MODEL_SCENE || resourceType == RESOURCE_TYPE.TRYON_SCENE) {
                if (sceneTags.length > 0) params.sceneTags = sceneTags?.join()
                if (compositionTags.length > 0) params.compositionTags = compositionTags?.join()
            } else if (resourceType == RESOURCE_TYPE.IMAGE) {
                if (inputImageClothType?.length > 0) params.inputImageClothType = inputImageClothType?.join()
            }
        }
        commonApiInvoker(api({
            ...params,
            pageIndex: 1,
            pageSize: totalRef.current
        })).then(res => {
            const total = res.total
            if (!total) {
                setList([])
                setIsEmpty(true)
                return
            }
            if (total !== totalRef.current) {
                totalRef.current = total
                commonApiInvoker(api({
                    ...params,
                    pageIndex: 1,
                    pageSize: totalRef.current
                })).then(res => {
                    const list = formatList(res?.items ?? [], selectedKeyList)
                    setList(list)
                    if (list.length == 0) setIsEmpty(true)
                    else setIsEmpty(false)
                })
            } else {
                const list = formatList(res?.items ?? [], selectedKeyList)
                setList(list)
                if (list.length == 0) setIsEmpty(true)
                else setIsEmpty(false)
            }
        })
    }, [
        force, resourceType,
        recommend, custom, favorite,
        selectedKeyList,
        resourceFilter
    ])

    // 选中列表
    const selectedKeyList = useMemo(() => {
        return value.map(item => item.key)
    }, [value])

    // 保存素材mask
    const saveMaterialPreference = (mask, item, semanticSimTryonMaskId, semanticSimTryonMaskId2) => {
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        commonApiInvoker(API.saveMaterialPreference({
            ...params,
            attr: {
                refMask: mask.binaryMask,
                foregroundAlphaMask: mask.foregroundAlphaMask,
                foregroundMask: mask.foregroundMask,
                semanticSimTryonMaskId,
                semanticSimTryonMaskId2
            },
            key: item?.name,
            custom: !!item?.custom,
        })).then(res => {
            // 更新素材列表
            updateForce({})
            // 更新已选中的glassesTryonKeyList
            const setUpdateList = resourceType == RESOURCE_TYPE.GLASSES_TRYON ? setGlassesTryonKeyList :
                resourceType == RESOURCE_TYPE.SIM_TRYON ? setSimTryonKeyList : null
            setUpdateList(prevList => {
                const updatedList = prevList.map(prevItem => {
                    if (prevItem.key === item.name) {
                        return {
                            ...prevItem,
                            attr: {
                                ...prevItem.attr,
                                refMask: mask.binaryMask,
                                foregroundAlphaMask: mask.foregroundAlphaMask,
                                foregroundMask: mask.foregroundMask,
                                semanticSimTryonMaskId,
                                semanticSimTryonMaskId2,
                            }
                        }
                    }
                    return prevItem;
                })
                return updatedList;
            })
        })
    }

    // 打开眼镜/同版型mask弹窗
    const onGlassesMattingOpt = async (item, semanticMaskId = null, semanticMaskId2 = null) => {
        let binaryMask, foregroundAlphaMask, foregroundMask, inputImage
        inputImage = item?.imageUrl || ''
        binaryMask = item?.attr?.refMask || ''
        foregroundAlphaMask = item?.attr?.foregroundAlphaMask || ''
        foregroundMask = item?.attr?.foregroundMask || ''
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            semanticMaskId,
            semanticMaskId2,
        }], resList => {
            const res = resList[0]
            if (!res) return
            saveMaterialPreference(res, item, semanticMaskId, semanticMaskId2)
        })
    }

    // 选中/取消选中
    const handleClick = async (item) => {
        if (resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON) {
            // 需要登录
            const status = Utils.checkLoginStatus(() => handleClick(item))
            if (!status) return
        }
        const temp = [...value]
        const index = temp.findIndex(i => i.key == item.name)
        if (index >= 0) { // 移除选项
            temp.splice(index, 1)
            onChange(temp)
        } else { // 添加选项
            // console.log('item', item)
            // 打开眼镜/同版型mask弹窗
            const isMask = item?.attr?.refMask // 有没有编辑过mask
            if (resourceType == RESOURCE_TYPE.GLASSES_TRYON && !isMask) {
                await onGlassesMattingOpt(item)
            } else if (resourceType == RESOURCE_TYPE.SIM_TRYON && !isMask) {
                // 先判断是否有语义分割ID
                const semanticSimTryonMaskId = item?.attr?.semanticSimTryonMaskId
                const semanticSimTryonMaskId2 = item?.attr?.semanticSimTryonMaskId2 // 全label分割结果
                if (semanticSimTryonMaskId) {
                    await onGlassesMattingOpt(item, semanticSimTryonMaskId, semanticSimTryonMaskId2)
                    return
                } else {
                    const res = await getSemanticSimTryonMaskId(item?.imageUrl)
                    const ids = res.split(":")
                    const semanticMaskId = ids[1]

                    const res2 = await getSemanticSimTryonMaskIdClothTypeAll(item?.imageUrl)
                    const ids2 = res2.split(":")
                    const semanticMaskId2 = ids2[1]
                    await onGlassesMattingOpt(item, semanticMaskId, semanticMaskId2)
                }
            }

            let _item = {
                key: item.name,
                attr: item.attr,
                title: item.attr.title,
                url: item.imageUrlWithVersion,
                custom: item.isCustom ? 1 : 0 // 0-预设 1-自定义
            }

            const refImgConfig = (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) ? {
                refImg: item.imageUrlWithVersion,
                refImgMask: item.attr.mask || null,
                refImgProcessed: item.attr.imgProcessed || null,
                refImgSize: {
                    width: item.attr.width,
                    height: item.attr.height
                },
                refImgLocalInfo: item.attr.objectLocationInfo || null,
                refImgPrompt: item.attr.prompt,
                // SAME_STYLE 需要将参考图加载到画布上，图像尺寸禁用; SIMILAR_STYLE 不需要
                refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
            } : null

            // 选择商品背景默认设置参考图分辨率及比例-----------
            if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
                const attr = _item.attr
                console.log('item.isCustom', item.isCustom)
                if (item.isCustom) setOutputRatio('custom')
                else setOutputRatio('1:1')
                setOutputWidth(attr?.width)
                setOutputHeight(attr?.height)
                setInputImageTransform()
                // 复刻一份原数据的url，用于裁剪后重选原始参考图分辨率
                _item = {
                    ..._item,
                    attr: {
                        ...attr,
                        originUrl: _item.url,
                        refCropUrl: _item.attr.refImage || _item.url,
                    }
                }
            }
            // --------------------------------------

            if (multiple) {
                temp.push(_item)
                onChange(temp.slice(-maxCount), refImgConfig)
            } else {
                onChange([_item], refImgConfig)
            }
        }
    }
    // 子项选中/取消选中
    const onMoreClick = (item, parent) => {
        const temp = [...value]
        const index = temp.findIndex(i => i.key == item.name)
        if (index >= 0) { // 移除选项
            temp.splice(index, 1)
            onChange(temp)
        } else { // 添加选项
            let _item = {
                key: item.name,
                attr: item.attr,
                title: item.attr.title,
                url: item.imageUrlWithVersion,
                custom: item.isCustom ? 1 : 0 // 0-预设 1-自定义
            }
            const refImgConfig = (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) ? {
                refImg: item.imageUrlWithVersion,
                refImgMask: item.attr.mask || null,
                refImgProcessed: item.attr.imgProcessed || null,
                refImgSize: {
                    width: item.attr.width,
                    height: item.attr.height
                },
                refImgLocalInfo: item.attr.objectLocationInfo || null,
                refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
            } : null

            // 选择商品背景默认设置参考图分辨率及比例-----------
            if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
                const attr = _item.attr
                if (item.isCustom) setOutputRatio('custom')
                else setOutputRatio('1:1')
                setOutputWidth(attr?.width)
                setOutputHeight(attr?.height)
                setInputImageTransform()
                // 复刻一份原数据的url，用于裁剪后重选原始参考图分辨率
                _item = {
                    ..._item,
                    attr: {
                        ...attr,
                        originUrl: _item.url,
                        refCropUrl: _item.attr.refImage || _item.url,
                    }
                }
            }
            // --------------------------------------

            if (multiple) {
                temp.push(_item)
                onChange(temp.slice(-maxCount), refImgConfig)
            } else {
                onChange([_item], refImgConfig)
            }
            setList(pre => {
                const temp = [...pre]
                for (let parentItem of temp) {
                    if (parentItem.id == parent.id) {
                        parentItem.id = item.id
                        parentItem.name = item.name
                        parentItem.imageUrl = item.imageUrl
                        parentItem.imageUrlWithVersion = item.imageUrlWithVersion
                        parentItem.isFavorite = item.isFavorite
                        parentItem.attr.name = item.attr.name
                        break
                    }
                }
                return temp
            })
        }
    }

    // 收藏/取消收藏
    const handleFavor = (record) => {
        const params = { ...RESOURCE_PARAMS[resourceType] }
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource2({
                ...params,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                if (favorite) {
                    updateForce({})
                } else {
                    setList(pre => {
                        const temp = [...pre]
                        const item = temp.find(item => item.id == record.id)
                        item.isFavorite = false
                        return [...temp]
                    })
                }
            })
        } else {
            commonApiInvoker(API.favoriteResource2({
                ...params,
                resourceId: record.id,
                custom: record.isCustom,
            })).then(res => {
                message.success("已收藏")
                if (favorite) {
                    updateForce({})
                } else {
                    setList(pre => {
                        const temp = [...pre]
                        const item = temp.find(item => item.id == record.id)
                        item.isFavorite = true
                        return [...temp]
                    })
                }
            })
        }
    }

    // 删除自定义参考图
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义参考图？`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    // 刷新列表
                    updateForce({})
                    // 刷新选中列表
                    if (value.find(item => item.key == record.name)) handleClick(record)
                })
            },
            onCancel() { },
        })
    }

    // 筛选列表
    const displayList = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) {
            if (commoditySceneMode == COMMODITY_SCENE_MODE.SAME_STYLE) { // 拍同款
                // return list.filter(item => item.attr.version == 3)
                return List
            } else { // 相似风格
                // return list.filter(item => item.attr.version != 3)
                return list
            }
        } else {
            return list
        }
    }, [list, resourceType, custom, commoditySceneMode])

    const showName = useMemo(() => {
        return resourceType == RESOURCE_TYPE.MODEL ||
            (resourceType == RESOURCE_TYPE.MODEL_SCENE && !custom) ||
            (resourceType == RESOURCE_TYPE.TRYON_SCENE && !custom) ||
            resourceType == RESOURCE_TYPE.COMMODITY_SCENE
    }, [resourceType])

    return (
        <div className={styles.SelectionContent}>
            {!custom && !favorite && !recommend &&
                resourceType != RESOURCE_TYPE.GLASSES_TRYON &&
                <SelectionFilter resourceType={resourceType} />}
            {/* {resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom &&
                <SceneModeSelection
                    value={commoditySceneMode}
                    onChange={handleCommoditySceneModeChange}
                />} */}
            <div className={`${styles.SelectionList} _none_scrollbar`}>
                {isEmpty &&
                    <div className={styles.SelectionListEmpty}>
                        <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/icon_empty.svg" />
                        <span>这里什么也没有哦~</span>
                    </div>}
                <div className={styles.SelectionListContent}>
                    {
                        custom &&
                        <SelectionItem.Uploader
                            commoditySceneMode={commoditySceneMode}
                            resourceType={resourceType}
                            onUpdate={() => updateForce({})}
                            onUpload={onUpload}
                        />
                    } {
                        displayList.map((item) => (
                            <SelectionItem
                                key={item.id}
                                isVideo={resourceType == RESOURCE_TYPE.VIDEO_MODEL}
                                overflowTips={resourceType == RESOURCE_TYPE.TRYON_MODEL ? "最多选择5张试衣参考图" :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? "最多选择5张鞋子参考图" :
                                        resourceType == RESOURCE_TYPE.POSE_TRYON ? "最多选择5张姿势参考图" : ""}
                                showName={showName}
                                record={item}
                                multiple={multiple}
                                actived={selectedKeyList.includes(item.name)}
                                overflow={multiple && maxCount <= selectedKeyList.length && !selectedKeyList.includes(item.name)}
                                favorDisabled={false}
                                onClick={handleClick}
                                onMoreClick={onMoreClick}
                                resourceType={resourceType}
                                toolGroup={{
                                    onFavor: () => handleFavor(item),
                                    onRemove: () => handleRemove(item)
                                }}
                            />
                        ))
                    }
                </div>
                {loading &&
                    <div className={styles.SelectionListLoading}>
                        <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/loadingBlue.gif" />
                        <span>加载中...</span>
                    </div>}
            </div>
        </div>
    )
}

const ColorSelectionContent = (props) => {
    const {
        value,
        onChange,
        favorite,
        imageType
    } = props
    const generateContext = useContext(GenerateContext)
    const {
        clothColorKeyList, setClothColorKeyList,
        colorKeyList, setColorKeyList,
    } = generateContext
    const recentColorList = JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
    const showRecent = recentColorList.length > 0
    // 收藏列表
    const [favoriteList, setFavoriteList] = useState([])
    // 刷新
    const [force, updateForce] = useState()
    // 调色盘open
    const [colorPaletteOpen, setColorPaletteOpen] = useState(false)

    useEffect(() => {
        // 需要登录
        if (!localStorage.getItem('token')) return
        commonApiInvoker(API.getFavoriteColors()).then(res => {
            setFavoriteList(res ?? [])
        })
    }, [force])

    const favoriteColorList = useMemo(() => {
        return favoriteList.map(item => item.color)
    }, [favoriteList])

    const favoriteColorData = useMemo(() => {
        const dataSetFalt = ColorDataSet.map(item => item.colors).flat()
        return favoriteList.map(item => {
            const item2 = dataSetFalt.find(item2 => item2.color == item.color)
            return item2 ? { ...item2 } : item
        })
    }, [favoriteList])

    // 点击颜色
    const handleClick = (item) => {
        const temp = [...value]
        const index = temp.findIndex(i => i == item.color)
        if (index >= 0) { // 移除选项
            onChange([])
        } else { // 添加选项
            onChange([item.color])
        }
    }

    // 收藏/取消收藏
    const handleFavor = (item) => {
        const favoriteItem = favoriteList.find(item2 => item2.color == item.color)
        console.log('handleFavor', item, favoriteItem)
        if (favoriteItem) {
            commonApiInvoker(API.unfavoriteColor({
                id: favoriteItem.id,
            })).then(res => {
                message.success("已取消收藏")
                updateForce({})
                eventBus.emit("update_favorite_color")
            })
        } else {
            commonApiInvoker(API.favoriteColor({
                color: item.color,
            })).then(res => {
                message.success('收藏成功')
                updateForce({})
                eventBus.emit("update_favorite_color")
            })
        }
    }

    return (
        <div className={styles.SelectionContent}>
            <div className={`${styles.SelectionList} _none_scrollbar`}>
                {
                    !favorite ?
                        <>
                            <ColorPalette
                                value={imageType == IMAGE_TYPE.CLOTH_RECOLOR ? clothColorKeyList[0] : colorKeyList[0]}
                                onChange={color => imageType == IMAGE_TYPE.CLOTH_RECOLOR ? setClothColorKeyList([color]) : setColorKeyList([color])}
                                open={colorPaletteOpen}
                                onOpenChange={setColorPaletteOpen}
                            >
                                <div style={{ width: "64px", cursor: "pointer" }}>
                                    <img className={styles.ColorPickerIcon} src={imageBaseUrlV3 + "colorPickerIcon.png"} alt="" />
                                    <p className={styles.ColorPickerIconTitle}>自定义</p>
                                </div>
                            </ColorPalette>
                            {
                                showRecent && (
                                    <div className={styles.ColorGroup}>
                                        <p className={styles.ColorGroup_name}>最近使用</p>
                                        <div className={styles.ColorGroup_list}>
                                            {
                                                recentColorList.map((item, index) => (
                                                    <div key={item + index} style={{ width: "64px" }}>
                                                        <SelectionColorItem
                                                            record={{
                                                                name: item,
                                                                color: item,
                                                            }}
                                                            showName={true}
                                                            showFavor={true}
                                                            onClick={() => imageType == IMAGE_TYPE.CLOTH_RECOLOR ? setClothColorKeyList([item]) : setColorKeyList([item])}
                                                            favorite={favoriteColorList.includes(item)}
                                                            onFavor={() => handleFavor({
                                                                name: item,
                                                                color: item,
                                                            })}
                                                        />
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }

                            {
                                ColorDataSet.map(item => (
                                    <div className={styles.ColorGroup} key={item.name}>
                                        <p className={styles.ColorGroup_name}>{item.name}</p>
                                        <div className={styles.ColorGroup_list}>
                                            {
                                                item.colors.map(item2 => (
                                                    <div key={item2.color} style={{ width: "64px" }}>
                                                        <SelectionColorItem
                                                            key={item2.color}
                                                            record={item2}
                                                            actived={value.includes(item2.color)}
                                                            favorite={favoriteColorList.includes(item2.color)}
                                                            onClick={handleClick}
                                                            onFavor={() => handleFavor(item2)}
                                                        />
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </>
                        :
                        <div className={styles.ColorGroup_list}>
                            {
                                favoriteColorData.map(item2 => (
                                    <div key={item2.color} style={{ width: "64px" }}>
                                        <SelectionColorItem
                                            key={item2.color}
                                            record={item2}
                                            actived={value.includes(item2.color)}
                                            favorite={favoriteColorList.includes(item2.color)}
                                            onClick={handleClick}
                                            onFavor={() => handleFavor(item2)}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                }
            </div>
        </div>
    )
}

const ImgToVideoContent = (props) => {
    const { type, setPrompt, resourceType, onChange, onClose, onUpload } = props
    const [force, updateForce] = useState()
    const [promptList, setPromptList] = useState([])
    const [promptOpen, setPromptOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [desc, setDesc] = useState('')
    const [editId, setEditId] = useState(null)

    // 推荐素材刷新
    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        const api = API.getCustomResources2
        commonApiInvoker(api({
            ...params,
            pageIndex: 1,
            pageSize: 50000
        })).then(res => {
            setPromptList(res?.items || [])
        })

    }, [
        force, resourceType
    ])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        const handler = () => updateForce({})
        eventBus.on('updateImgToVideoPrompt', handler)
        return () => {
            eventBus.off('updateImgToVideoPrompt', handler)
        }
    }, [resourceType])

    const promptGroups = useMemo(() => ([
        {
            key: 'subject',
            title: '主体',
            options: ['女人', '男人', '男孩', '女孩'],
        },
        {
            key: 'action',
            title: '动作',
            options: ['服饰展示', '往前行走', '右手抬起', '模特台步', '身体自然左右晃动', '手自然插入口袋'],
        },
        {
            key: 'camera',
            title: '运镜',
            options: ["镜头固定", "镜头从左往右", "镜头从右往左", "镜头推进", "镜头拉远", "镜头上摇", "镜头下摇", "环绕运镜", "原地旋转展示", "左旋推进", "右旋推进", "推进上移", "推进拉远"],
        }
    ]), [])


    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这段提示词吗？`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    // 刷新列表
                    updateForce({})
                })
            },
            onCancel() { },
        })
    }

    const handleAddPrompt = async () => {
        if (!desc) {
            message.error('请输入描述')
            return
        }
        const res2 = await API.saveCustomMaterialv2({
            ...(editId ? { id: editId } : {}),
            func: IMAGE_TYPE.IMAGE_TO_VIDEO,
            type: 'image2VideoPrompt',
            image: desc?.trim(),
            attr: {
                title: title?.trim() || '未命名标题',
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        setPromptOpen(false)
        setEditId(null)
        updateForce({})
    }

    return (
        <div className={styles.ImgToVideoContent}>
            {
                type == 'prompt' ? (
                    <div className={`${styles.ImgToVideoContent_prompt} _none_scrollbar`}>
                        {promptGroups.map(group => (
                            <div key={group.key} className={styles.ImgToVideoContent_promptGroup}>
                                <div className={styles.ImgToVideoContent_promptTitle}>{group.title}</div>
                                <div className={styles.ImgToVideoContent_promptOptions}>
                                    {group.options.map(opt => (
                                        <Button
                                            key={`${group.key}_${opt}`}
                                            className={`${styles.ImgToVideoContent_promptBtn}`}
                                            onClick={() => setPrompt(prev => (prev ? `${prev}${opt}，` : `${opt}，`))}
                                        >
                                            {opt}
                                        </Button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : type == 'mine' ? (
                    <div className={`${styles.ImgToVideoContent_mine} _none_scrollbar`}>
                        <Button
                            className={styles.ImgToVideoContent_mineAddBtn}
                            onClick={() => {
                                setEditId(null)
                                setTitle('')
                                setDesc('')
                                setPromptOpen(true)
                            }}
                        >
                            <Iconfont type="icon-general_dd" className={styles.Icon} /> 新增提示词</Button>
                        {promptList?.map(item => (
                            <div key={item.key} className={styles.ImgToVideoContent_mineItem} onClick={() => setPrompt(item.imageUrl)}>
                                <div className={styles.ImgToVideoContent_mineHeader}>
                                    <div className={styles.ImgToVideoContent_mineActions}>
                                        <Iconfont type="icon-editOutlined" className={styles.Icon} onClick={(e) => {
                                            e.stopPropagation()
                                            setEditId(item.id)
                                            setTitle(item.attr?.title || '')
                                            setDesc(item.imageUrl || '')
                                            setPromptOpen(true)
                                        }} />
                                        <Iconfont type="icon-DeleteOutlined" className={styles.Icon} onClick={(e) => {
                                            e.stopPropagation()
                                            handleRemove(item)
                                        }} />
                                    </div>
                                    <div className={styles.ImgToVideoContent_mineTitle}>{item.attr?.title}</div>
                                </div>
                                <div className={styles.ImgToVideoContent_mineDesc}>{item.imageUrl}</div>
                            </div>
                        ))}
                    </div>
                ) : null
            }
            <PSAIModal
                title="新增提示词"
                open={promptOpen}
                maskClosable={false}
                maxWidth={750}
                onCancel={() => setPromptOpen(false)}
                onOk={handleAddPrompt}
                getContainer={"body"}
                zIndex={10000}
            >
                <div className={styles.ImgToVideoContent_modalForm}>
                    <div className={styles.ImgToVideoContent_modalItem}>
                        <div className={styles.ImgToVideoContent_modalLabel}>标题</div>
                        <Input
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="请输入标题"
                            className={styles.ImgToVideoContent_modalInput}
                        />
                    </div>
                    <div className={styles.ImgToVideoContent_modalItem}>
                        <div className={styles.ImgToVideoContent_modalLabel}>描述</div>
                        <TextArea
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            placeholder="请输入描述"
                            maxLength={800}
                            autoSize={{ minRows: 16, maxRows: 16 }}
                            className={styles.ImgToVideoContent_modalTextArea}
                        />
                    </div>
                </div>
            </PSAIModal>
        </div>
    )
}

/**
 * Pose selection content
 * 姿势选择内容
 * @param {string} value Selected value
 * @param {boolean} customDisabled Whether the custom tab is disabled
 * @param {string} resourceType Resource type
 * @param {boolean} multiple Whether the drawer is multiple selection
 * @param {function} onChange Callback when the selected value changes
 * @param {function} onClose Callback when the drawer is closed
 * @param {string} defaultActiveKey Default active key of tabs
 */
const PoseSelection = (props) => {
    const { value, defaultActiveKey, customDisabled, resourceType, multiple, imageType, onClose, onChange, onUpload, setPrompt } = props

    const presetTitle = useMemo(() => {
        const triggerText = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "预设参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "预设参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "预设参考图" :
                    resourceType == RESOURCE_TYPE.SIM_TRYON ? "预设参考图" :
                        resourceType == RESOURCE_TYPE.MODEL ? "预设模特" :
                            resourceType == RESOURCE_TYPE.MODEL_SCENE ? "预设背景" :
                                resourceType == RESOURCE_TYPE.TRYON_SCENE ? "预设背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? "预设参考图" :
                                        resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "预设动作" :
                                            resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "预设背景" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? "预设颜色" :
                                                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "预设颜色" :
                                                        ""
        return triggerText
    }, [resourceType])

    const items = useMemo(() => {
        // const favorDisabled = (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.MODEL) ||
        //     resourceType == RESOURCE_TYPE.TRYON_SCENE
        let res = [{
            key: 'preset',
            label: presetTitle,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} multiple={multiple} maxCount={5} value={value} onChange={onChange} />,
            destroyOnHidden: true
        }, {
            key: 'custom',
            label: `本地上传`,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} custom multiple={multiple} maxCount={5} value={value} onChange={onChange} onUpload={onUpload} />,
            destroyOnHidden: true,
            disabled: customDisabled,
        }, {
            key: 'collect',
            label: `我的收藏`,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} favorite multiple={multiple} maxCount={5} value={value} onChange={onChange} />,
            destroyOnHidden: true
        }].filter(item => !!item)
        if (resourceType == RESOURCE_TYPE.TRYON_MODEL ||
            resourceType == RESOURCE_TYPE.SIM_TRYON ||
            resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            res.unshift({
                key: 'recommend',
                label: `智能推荐`,
                children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} recommend multiple={multiple} maxCount={5} value={value} onChange={onChange} />,
                destroyOnHidden: true
            })
        } else if (resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR) {
            res = [{
                key: 'preset',
                label: `色板`,
                children: <ColorSelectionContent imageType={imageType} value={value} onChange={onChange} />,
                destroyOnHidden: true
            }, {
                key: 'collect',
                label: `我的收藏`,
                children: <ColorSelectionContent favorite value={value} onChange={onChange} />,
                destroyOnHidden: true
            }]
        } else if (resourceType == RESOURCE_TYPE.IMAGE_TO_VIDEO) {
            res = [{
                key: 'prompt',
                label: `预设词库`,
                children: <ImgToVideoContent type='prompt' resourceType={resourceType} setPrompt={setPrompt} />,
                destroyOnHidden: true
            }, {
                key: 'mine',
                label: `我的模板`,
                children: <ImgToVideoContent type='mine' resourceType={resourceType} setPrompt={setPrompt} />,
                destroyOnHidden: true
            }]
        }
        return res
    }, [resourceType, presetTitle, multiple, value, onChange, onUpload, customDisabled])


    return (
        <Tabs
            defaultActiveKey={defaultActiveKey}
            className={styles.DrawerTabs}
            size="small"
            tabBarExtraContent={<CloseOutlined style={{ cursor: "pointer" }} onClick={onClose} />}
            items={items}
        />
    )
}

/**
 * Drawer of reference selection
 * 参考选择抽屉
 * @param {string} value Selected value
 * @param {boolean} open Whether the drawer is open
 * @param {function} onOpenChange Callback when the drawer is opened or closed
 * @param {string} defaultActiveKey Default active key of tabs
 * @param {boolean} customDisabled Whether the custom tab is disabled
 * @param {string} resourceType Resource type
 * @param {boolean} multiple Whether the drawer is multiple selection
 * @param {function} onChange Callback when the selected value changes
 */
const ReferSelectionDrawer = (props) => {
    const { open, onOpenChange, ...restProps } = props
    const nodeRef = useRef(null)
    const [showContent, setShowContent] = useState(false)
    const { setPrompt } = useContext(GenerateContext)


    return (
        <>
            <CSSTransition
                in={!!open}
                nodeRef={nodeRef}
                timeout={200}
                unmountOnExit
                classNames={{
                    enter: styles.DrawerEnter,
                    enterActive: styles.DrawerEnterActive,
                    enterDone: styles.DrawerEnterDone,
                    exit: styles.DrawerExit,
                    exitActive: styles.DrawerExitActive,
                    exitDone: styles.DrawerExitDone,
                }}
                onEntered={() => setShowContent(true)}
                onExit={() => setShowContent(false)}
            >
                <div ref={nodeRef} className={styles.DrawerContain} onClick={() => onOpenChange(false)}>
                    <div className={styles.DrawerContent} onClick={e => e.stopPropagation()}>
                        {
                            showContent &&
                            <PoseSelection
                                setPrompt={setPrompt}
                                key={restProps.resourceType}
                                onClose={() => onOpenChange(false)}
                                onMattingOpt={props.onMattingOpt}
                                {...restProps}
                            />
                        }
                    </div>
                </div>
            </CSSTransition>
        </>

    )
}

export default ReferSelectionDrawer